<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<div>
  <v-row>
      <v-col
        cols="12"
        class="text-center subheading pt-0 mb-3 mt-3"
        style="font-weight: 500;"
      >Hospital Beds Compared to Deaths and Cases</v-col>
    </v-row>
    <v-row style="height: 100%;" class="pa-3 pt-0">
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="5"
        :hide-default-footer="true"
        class="elevation-0 transparent"
        dark
        style="width: 100%"
      >
      <template v-slot:item.diff="{ item }">
        <v-icon v-if="item.diff > 0" size="18" color="#fa5e5b">warning</v-icon>
        <v-icon v-if="item.diff === 0" size="18" color="#ffc83f">warning</v-icon>
      </template>
        <template v-slot:item.country="{ item }">
          <div class="caption grey--text text--lighten-1" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit' }">{{ item.country }}</div>
        </template>
        <template v-slot:item.beds="{ item }">
          <div class="caption purple--text text--lighten-2" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit', 'font-weight': '600' }">{{ getNumberDisplay(item.beds) }}</div>
        </template>
        <template v-slot:item.deathsper100k="{ item }">
          <div class="caption pink--text text--lighten-2" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit' }">{{ getNumberDisplay(item.deathsper100k) }}</div>
        </template>
        <template v-slot:item.confirmedper100k="{ item }">
          <div class="caption blue--text text--lighten-2" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit' }">{{ getNumberDisplay(item.confirmedper100k) }}</div>
        </template>
      </v-data-table>
    </v-row>
</div>
</template>

<script>
export default {
  name: "LowHospital",
  data: () => ({
    items: [],
    headers: [
      { text: '', value: 'diff' },
      { text: 'Country', value: 'country' },
      { text: 'Beds per 100k pop.', value: 'beds' },
      { text: 'Deaths per 100k pop.', value: 'deathsper100k' },
      { text: 'Confirmed per 100k pop.', value: 'confirmedper100k' }
    ],
    countrySelected: false,
  }),
  methods: {
    loadCases(data, countryDisplay) {
      //clear data
      this.items = [];

      //check no data
      if (data.length === 0) {
        return;
      }

      if(countryDisplay && countryDisplay !== "") {
        this.countrySelected = true
      }
      else {
        this.countrySelected = false
      }

      //calculate the beds per 100 and the confirmed per 100 and compare them
      //the countries with the highest difference are the ones to be watched
      var topcountries = [];
      for (var i = 0; i < data.length; i++) {
        
        //find hospital beds per 100k population
        var beds = data[i].population.hospital_beds_100k*1

        //calculate the latest confirmed per 100k population
        var latestconfirmed = data[i].cases[data[i].cases.length - 1].cumulative_cases
        var totalpop = data[i].population.population*1

        var cper100k = (latestconfirmed/totalpop) * 100000
        cper100k = parseFloat(cper100k.toFixed(0))

        //calculate the latest deaths per 100k population
        var latestdeaths = data[i].cases[data[i].cases.length - 1].cumulative_deaths

        var dper100k = (latestdeaths/totalpop) * 100000
        dper100k = parseFloat(dper100k.toFixed(0))

        //the diff
        var diff = dper100k - beds

        topcountries.push({
          country: data[i].Country_WHO,
          confirmedper100k: cper100k,
          deathsper100k: dper100k,
          beds: beds,
          diff: diff
        });
      }

      //sort by diff desc
      topcountries = topcountries.sort(function (a, b) {
        a = a.diff;
        b = b.diff;
        return a > b ? -1 : a < b ? 1 : 0;
      });

      //only take the top ones
      topcountries = topcountries.slice(0, 5);

      this.items = topcountries;

    },
    getNumberDisplay(number) {
      return number.toLocaleString("en").replace(/\,/g, " ");
    },
    getCasesForDay(date, cases) {
      var cumulative = 0
      
      var match = cases.find(c => c.date === date)
      if(match) {
        cumulative = match.cumulative_cases
      }

      return cumulative
    },
  },
};
</script>